import React from 'react';

function LoadingScreen() {
  return <div>LOADING DATA...(REACT LAZY LOADING WITH SUSPENSE)</div>;
}

export default LoadingScreen;
